import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=c7bbbdc0&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bbbdc0",
  null
  
)

export default component.exports